import { axiosInstance } from './axios.utils';

export async function generatePDFFromAPI(assetId, templateType = 'riseai', authToken = null) {
  const endpoint = '/generate-pdf';

  const requestBody = {
    assetId,
    templateType
  };

  const headers = {
    'Content-Type': 'application/json'
  };

  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  try {
    const response = await axiosInstance.post(endpoint, requestBody, {
      headers,
      responseType: 'blob'
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export function downloadPDF(pdfBlob, filename = 'document.pdf') {
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const link = document.createElement('a');
  link.href = pdfUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);
}
